import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpcatalogtestpaths0getGetScreenTruthTestPathsResponseSchema = jsonObject
export type tcpcatalogtestpaths0getGetScreenTruthTestPathsResponse = z.infer<typeof tcpcatalogtestpaths0getGetScreenTruthTestPathsResponseSchema>
